import React, { useState } from "react";
import {
  Button,
  Grid,
  makeStyles,
  Paper,
  Typography,
  TextField,
  IconButton,
  Switch,
  Card,
} from "@material-ui/core";

import DetailsCard from "./detailsCard";
import { SelectBox } from "../../../../../../components/common/smartForm/component";
import { actions } from "primary_care_admin_binder";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { AlertContext } from "../../../../../../contexts";
import { AlertProps, validationFormEnbty } from "../../../../../../utils";
import styles from "../../../../../../components/common/smartForm/styles";
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import EditIcon from "@material-ui/icons/EditOutlined";
// import { AlertProps, AxiosCall } from "../../../utils";

// validation field keys json
const validationList = []

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "20px",
    borderRadius: "0px 0px 8px 8px",
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },
  },
  addBtn: {
    float: "right",
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "none",
  },
  formtitle: {
    fontSize: "12px",
    paddingBottom: 9,
    Fontfamily: "pc_regular",
    color: "#6F6F6F",
  },
  textfieldGrid: {
    marginTop: "4px",
  },

  SecondGrid: {
    marginTop: 15,
    padding: 10,
    border: "1px solid #E0E0E0",
    borderRadius: 8,
  },
  title: {
    fontFamily: "poppinsemibold",
    fontSize: "12px",
    marginBottom: 10,
  },
  maintitle: {
    marginTop: 10,
    fontFamily: "poppinsemibold",
    fontSize: "14px",
  },
}));

function ObservationTab(props) {
  const classes1 = useStyles();
  const classes = styles();
  const alert = React.useContext(AlertContext);

  const [collapse, setCollaplse] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [editshow, seteditshow] = useState(false);
  const [currentEditIndex, setCurrentEditIndex] = useState(null);
  const handleClick = async (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentEditIndex(null);
  };
  const [error, setError] = useState();
  const [observation, setObservation] = useState({
    vitalcode: "",
    mandatory: false,
    sequence: ""
  });

  const [valueshow, setvalueshow] = useState([]);


  const [state, setState] = React.useState({
    encounterType: null,
    gender: null,
    ageRange: null,
    agecategory: [],
    patientInstrction: "",
    practitionerInstrction: "",
    prepratoryInstrction: "",
    departmentInstrction: "",
    _id: "",
    editIndex: null,
  });

  let dispatch = useDispatch();
  const service = useSelector((state) => state?.orderCatalogSlice);

  const handleOpen = () => {
    setCollaplse(!collapse);
  };

  // forStateChange;
  const { handleFormState, parent_id,observationList } = props;

  const handleChangelist = async (key, value) => {
    setObservation({
      ...observation,
      [key]: value,
    });
};

  const handlesubmit = () => {
    if (currentEditIndex !== null) {
      if( observation?.vitalcode?.label &&
        observation?.sequence ){
          // let updatedObervation = finalValue.observationdetails 
          // updatedObervation[currentEditIndex] = observation;
          const updatedValues = [...observationList];
          updatedValues[currentEditIndex] = observation;
          // setvalueshow(updatedValues);
          handleFormState("observationList", updatedValues);
          setObservation({
            vitalcode: "",
            sequence: "",
            mandatory: false
          });
          setCurrentEditIndex(null);
          setAnchorEl(null);
          seteditshow(false);
      } else {
        alert?.setSnack({
          open: true,
          severity: AlertProps.severity.error,
          msg: "Please fill all the mandatory fields!",
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.right,
          tone: true,
        });
      }
    } else {
      if (
        observation?.vitalcode?.label &&
        observation?.sequence
      ) {
        if (observationList.some(item => item?.vitalcode?._id === observation?.vitalcode?._id
        )) {
          alert?.setSnack({
              open: true,
              severity: AlertProps.severity.warning,
              msg: "Existing vitalcode Can't Be Added Again!",
              vertical: AlertProps.vertical.top,
              horizontal: AlertProps.horizontal.right,
              tone: true,
          });
          return ;
      }
      if (observationList.some(item => item?.sequence === observation?.sequence
      )) {
        alert?.setSnack({
            open: true,
            severity: AlertProps.severity.warning,
            msg: "Existing sequence Can't Be Added Again!",
            vertical: AlertProps.vertical.top,
            horizontal: AlertProps.horizontal.right,
            tone: true,
        });
        return ;
    }
        const updatedValues = [...observationList, observation];
        // setvalueshow(updatedValues);
        handleFormState("observationList", updatedValues);
        setError(false)

      } else {
        setError(true)
        alert?.setSnack({
          open: true,
          severity: AlertProps.severity.error,
          msg: "Please fill all the mandatory fields!",
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.right,
          tone: true,
        });
        return;
      }
      setObservation({
        vitalcode: "",
        mandatory: false,
        sequence: ""
      });
      setAnchorEl(null);
    }
  };

const handleEditvalue = (v, i) => {
  seteditshow(true);
  setCurrentEditIndex(i);
  setObservation({
      vitalcode: v?.vitalcode,
      mandatory: v?.mandatory,
      sequence: v?.sequence
  });
};


const deleteObs = (index) => {
    const updatedList = observationList.filter((_, i) => i !== index);
  if (handleFormState) {
    handleFormState('observationList', updatedList);
  }
}

  return (
       <React.Fragment>
        <Paper
                id={`${parent_id}-parent-paper`}
                className={classes1.root} elevation={0}>
        <div style={{ padding: 18  }}>
          <Grid container spacing={2} lg={12} alignItems="center">
                <Grid
                   item lg={3} md={3}
                >
                    <Typography
                    style={{
                      color: "#6F6F6F",
                      fontSize: 14,
                      marginBottom: 4,
                      marginTop: 0,
                    }}
                    >
                    Vital Code{" "}
                    </Typography>
                    <SelectBox
                    // parent_id={"vitalCode-select"}
                    value={observation?.vitalcode ?? []}
                    onchange={(e, v) =>
                      handleChangelist("vitalcode",v)
                    }
                    list={
                       Array.isArray(service?.res_orderCatalog_vitalCode?.data)
                        ? service?.res_orderCatalog_vitalCode?.data
                        : []
                    }
                    
                    // error={error && !resourse?.servicetype?.label}
                    />
                </Grid>
                <Grid
                    item lg={3} md={3}
                >
                    <Typography
                    style={{
                      color: "#6F6F6F",
                      fontSize: 14,
                      marginBottom: 4,
                      marginTop: 0,
                    }}
                    >
                    Sequence
                    </Typography>
                    <TextField
                    id={`Sequence-Code-textField`}
                    // disabled={Boolean(editData)}
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={observation?.sequence ?? []}
                    onChange={(e) => {
                      if (/^[0-9\s@\/]*$/.test(e.target.value)) {
                          handleChangelist("sequence", Number(e.target.value ?? ""))
                      }
                    }
                  }
                    />
                </Grid>
                <Grid
                    item lg={3} md={3}
                >
                    <Typography
                   style={{
                      color: "#6F6F6F",
                      fontSize: 14,
                      marginBottom: 4,
                      marginTop: 0,
                    }}
                    >
                    Mandatory
                    </Typography>
                    <Switch
                    checked={observation?.mandatory}
                    onClick={(e) => handleChangelist("mandatory",e.target.checked)}
                    color="primary"
                    name="checkedB"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                    value={observation?.mandatory}
                    />  
                                     
                </Grid>
                <Grid item lg={3} md={3}>
                <Button
            variant="outlined"
            size="medium"
            style={{ marginRight: "20px" }}
            // onClick={() => {
            //   handleClose();
            // }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="medium"
            // color="primary"
            style={{
              marginRight: "34px",
              backgroundColor: "#0071F2",
              color: "white",
            }}
            onClick={() => handlesubmit()}
          >
            {/* {editshow ? "update" : "+ADD"} */}
            {"+ ADD"}
          </Button>
                </Grid>
              </Grid>
        </div>


        
      
        <Card
          style={{
            marginTop: "5px",
            borderRadius: "5px",
          }}
        >
         
        </Card>
        <Card
          style={{
            marginTop: "5px",
            borderRadius: "5px",
          }}
        >
          
        

        {observationList?.length > 0 &&
            observationList?.map((v, i) => {
              return (
                <Grid
                  container
                  style={{
                    border: "1px solid #E0E0E0",
                    padding: 12,
                    // marginBottom: 8,
                    backgroundColor: "#F9F9F9",
                    position: "relative",
                  }}
                  direction="row"
                  alignItems="center"
                >
                  <Grid item xs={6}>
                    <Grid
                      container
                      direction="row"
                      justify="flex-end"
                      alignItems="center"
                    >
                      <Grid
                        item
                        xs={1}
                        style={{
                          backgroundColor: "#E0E0E0",
                          position: "absolute",
                          left: 0,
                          padding: "6px 12px",
                          borderTopRightRadius: 9,
                          borderBottomRightRadius: 9,
                        }}
                      >
                        {i + 1}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{
                          marginLeft: "4%",
                          display: "flex",
                          padding: 10,
                        }}
                      >
                         <Grid style={{ marginLeft: "10px" 
                         }}>
                          {v.vitalcode?.label}
                        </Grid>
                        <Grid style={{ marginLeft: "10px" }}>
                          {v.sequence}
                        </Grid>
                        <Grid style={{ marginLeft: "10px" }}>
                          {v.mandatory?"Mandatory":""}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-end"
                      alignItems="center"
                    >
                      <IconButton
                        aria-label="EditIcon"
                        className={classes.margin}
                        size="small"
                      >
                        <EditIcon
                          onClick={(e) => {
                            handleClick(e);
                            handleEditvalue(v, i);
                          }}
                          style={{ color: "#0071F2", fontSize: 18 }}
                        />
                      </IconButton>
                      <IconButton
                        aria-label="DeleteIcon"
                        className={classes.margin}
                        size="small"
                        onClick={() => deleteObs(i)}
                      >
                        <DeleteIcon
                          style={{ color: "#FF4D4A", fontSize: 18 }}
                        />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}

          </Card>
        </Paper>
        </React.Fragment>
  
  );
}

export default ObservationTab;
